export default __webpack_public_path__ + "static/media/IconDesc_SpelevatorPart_4.256.6be0fe64.png";